"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSocketStatusById = exports.selectSocketById = void 0;
var _constants = require("../../../utils/constants");
var _socketConfig = require("../../../shared/api/webSockets/lib/socket-config");
const selectSocketById = _ref => {
  let {
    socketId
  } = _ref;
  return _ref2 => {
    let {
      [_constants.packageKey]: {
        sockets
      } = {}
    } = _ref2;
    return ((sockets === null || sockets === void 0 ? void 0 : sockets.byId) || {})[socketId] || null;
  };
};
exports.selectSocketById = selectSocketById;
const selectSocketStatusById = _ref3 => {
  let {
    socketId
  } = _ref3;
  return _ref4 => {
    let {
      [_constants.packageKey]: {
        sockets
      } = {}
    } = _ref4;
    return (((sockets === null || sockets === void 0 ? void 0 : sockets.byId) || {})[socketId] || {}).readyState || _socketConfig.readyStates.CLOSED;
  };
};
exports.selectSocketStatusById = selectSocketStatusById;